import { fg } from '@atlassian/jira-feature-gating';

const GroupByAgentSessionsSubPropertyRelayProvider = {
	get(): boolean {
		return fg('group_by_agent_sessions_sub_property');
	},
};

export default GroupByAgentSessionsSubPropertyRelayProvider;
